import { Directive, ElementRef, Renderer2, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[pluginsTrim]',
  standalone: true,
  host: { '(blur)': 'onBlur()' },
})
export class TrimDirective {
  private readonly renderer = inject(Renderer2);
  private readonly control = inject(NgControl, { optional: true, self: true });
  private readonly elementRef =
    inject<ElementRef<HTMLInputElement | HTMLTextAreaElement>>(ElementRef);

  onBlur() {
    const value = this.elementRef.nativeElement.value;
    const trimmed = value.trim();

    if (value === trimmed) {
      return;
    }

    if (this.control) {
      this.control.control?.setValue(trimmed);
    } else {
      this.renderer.setValue(this.elementRef.nativeElement, trimmed);
    }
  }
}
